import { render, staticRenderFns } from "./DataTableView.vue?vue&type=template&id=d32fe2ca&scoped=true"
import script from "./DataTableView.vue?vue&type=script&lang=js"
export * from "./DataTableView.vue?vue&type=script&lang=js"
import style0 from "./DataTableView.vue?vue&type=style&index=0&id=d32fe2ca&prod&lang=scss&scoped=true"
import style1 from "./DataTableView.vue?vue&type=style&index=1&id=d32fe2ca&prod&scoped=true&lang=css"
import style2 from "./DataTableView.vue?vue&type=style&index=2&id=d32fe2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32fe2ca",
  null
  
)

export default component.exports